<script>
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import Vue from 'vue'
import StarRating from 'vue-star-rating'
// import Donut from 'vue-css-donut-chart'
// import 'vue-css-donut-chart/dist/vcdonut.css'
import myVideo from 'vue-video'
// Vue.use(Donut)
export const EventBus = new Vue()
export default {
  name: 'profile-modal',
  data () {
    return {
      userid: '',
      base_urls: BaseURL,
      profiledetails: [],
      profilesills: [],
      groupeddate: [],
      startdate: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      enddate: '',
      selectpost: '',
      tabOne: true,
      tabTwo: false,
      tabthree: false,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      validationerror: false,
      rating: 0,
      userResumeandVideo: [],
      resumeurl: '',
      videourl: '',
      sections:
      [
        { value: 75, color: '#f39c12' }
      ],
      video: [],
      showRole: false
    }
  },
  components: {
    StarRating,
    myVideo
  },
  props: {
    shwovalueProfileProfile: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    // this.$refs.videoRef.src = 'http://iandevlin.github.io/mdn/video-player/video/tears-of-steel-battle-clip-medium.mp4'
    // this.$refs.videoRef.play()
  },
  created () {
    this.shwovalueProfile = true
    this.userid = JSON.parse(localStorage.getItem('viewid'))
    this.selectpost = JSON.parse(localStorage.getItem('postId'))
    this.startdate = ''
    this.enddate = ''
    this.getdata()
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      this.showRole = true
    }
  },
  methods: {
    SendMessageToParent () {
      this.$root.$emit('message_from_abc', this.selectpost)
      this.$emit('input', !this.shwovalueProfile)
    },
    scrollToElement () {
      const el = this.$el.getElementsByClassName('scroll-to-me')[0]
      if (el) {
        el.scrollIntoView()
      }
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
      console.log(this.groupeddate)
    },
    getdatetime (start, end) {
      this.validationerror = false
      this.startdate = start
      this.enddate = end
    },
    uninterestRequest () {
      this.postdatas = []
      const mainurl = '/dashboard/update_org_uninterest/web'
      this.postdatas = {
        post_id: this.selectpost,
        user_id: this.userid,
        org_id: this.userInfo._id
      }
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        console.log(response.data)
        // this.getPostdata(this.selectpost,'no');
        this.SendMessageToParent()
      }).catch(e => {
        console.log(e)
      })
    },
    interestRequest (type) {
      console.log('enter')
      EventBus.$emit('i-got-clicked', this.userid)
      console.log('enter')
      // if (this.startdate === '' || this.startdate === null || this.startdate === undefined) {
      //   this.validationerror = true
      //   this.tabTwo = true
      //   this.tabOne = false
      //   this.scrollToElement()
      //   return false
      // }
      const mainurl = '/dashboard/add_org_interest/web'
      this.postdatas = {
        post_id: this.selectpost,
        user_id: this.userid,
        org_id: this.userInfo._id
      }
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        console.log(response.data)
        // this.getPostdata(this.selectpost,'no');
        if (type === 1) {
          this.$awn.success('Request sent')
        } else {
          this.$awn.success('Accepted successfully')
        }
        this.SendMessageToParent()
      }).catch(e => {
        console.log(e)
      })
    },
    close () {
      this.$emit('input', !this.shwovalueProfile)
    },
    getdata () {
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      const mainurl = '/dashboard/get_profile_detail/' + this.userid + '/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.profiledetails = response.data.profileDetail[0]
        this.profilesills = response.data.profileSkillList
        this.userResumeandVideo = response.data.userResumeandVideo
        if (this.userResumeandVideo) {
          for (let k = 0; k < this.userResumeandVideo.length; k++) {
            if (this.userResumeandVideo[k].type === 'resume') {
              this.resumeurl = this.userResumeandVideo[k].certifications_name
            }
            if (this.userResumeandVideo[k].type === 'video') {
              this.videourl = this.userResumeandVideo[k].certifications_name
            }
          }
        }
        this.video = {
          sources: [{
            src: this.videourl,
            type: 'video/mp4'
          }],
          options: {
            autoplay: true,
            volume: 0.6,
            poster: 'http://covteam.u.qiniudn.com/poster.png'
          }
        }
        this.rating = this.profiledetails.interviewer_rating
        this.groupBy(response.data.availabilityDetails, 'startdate')
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<template>
<!-- <div class="custom-modal-backdrop" v-show="shwovalueProfile">  -->
  <div class="modal fade1 in" id="modal-default" style="display: block;" v-show="shwovalueProfile">
  <div class="modal-dialog" style="margin-top:15px">
    <div class="modal-content">
      <div class="modal-header">
        <span data-dismiss="modal" @click="close()" class="pop-up-close-icon"><i aria-hidden="true" class="uil uil-times"></i></span>
        <h4 class="modal-title">Profile</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6 p-1">
            <div class="col-md-2 p-1">
              <!-- <img src="../../assets/img/default.png" class="img-circle" alt="User Image"> -->
              <img v-if="profiledetails.profile_picture !='' && profiledetails.profile_picture !=null" :src="`${profiledetails.profile_picture}`" class="img-circle">
              <img v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == null" src="../../assets/img/default.png" class="img-circle">
              <img v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'Female'" src="../../assets/img/female_default.png" class="img-circle">
              <img v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'Male'" src="../../assets/img/male_default.png" class="img-circle">
            </div>
            <div class="col-md-10">
              <div class="col-md-6 p-1">
                <div>
                  <span class="direct-chat-timestamp pull-left f12">First Name</span><br>
                  <span class="direct-chat-name pull-left f12">{{profiledetails.first_name}}</span>
                </div><br>
                <div class="mt-2">
                <span class="direct-chat-timestamp pull-left f12">Designation</span><br>
                <span class="direct-chat-name pull-left f12">{{profiledetails.designation}}</span>
                </div>
              </div>
              <div class="col-md-6 p-1">
                <div>
                  <span class="direct-chat-timestamp pull-left f12">Last Name</span><br>
                  <span class="direct-chat-name pull-left f12">{{profiledetails.last_name}}</span>
                </div><br>
                <div class="mt-2">
                  <span class="direct-chat-timestamp pull-left f12">Experience</span><br>
                  <span class="pull-left"><span class="direct-chat-name f12">{{profiledetails.experience}}</span>  <span class="direct-chat-timestamp f12">Years</span> <span class="direct-chat-name f12">{{profiledetails.month_of_experience}}</span> <span class="direct-chat-timestamp f12">Months</span></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <span class="direct-chat-timestamp pull-right" style="font-size: small;">Rating</span>
            </div>
            <div class="row">
              <div class="col-md-8">
                <span v-if="!showRole" class="direct-chat-timestamp pull-left">Cost Per Interview <button disabled><i class="uil uil-rupee-sign"></i>{{profiledetails.interview_cost}}</button></span>
              </div>
              <div class="col-md-4 p-1">
                <span class="pull-right">
                <star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="Number(rating)" :read-only="true"></star-rating>
              </span>
              </div>
            </div>
            <div class="row mt-2 mb-2">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <button class="btn btn-default btns pull-left"><i class="uil uil-bookmark" aria-hidden="true"></i> Bookmark</button>
              </div>
              <div class="col-md-4 p-1" v-if="profiledetails.isclient =='no'">
                <a v-if="(profiledetails.status =='Interest' || profiledetails.status =='' || profiledetails.status ==null) && (profiledetails.statusval !=='Declined' && profiledetails.statusval !=='cancelled') && !showRole" class="button btn-align sbtn mr-3 btn-sm accent-btn rounded pull-right raised" @click="interestRequest(1)"><i class="uil uil-thumbs-up" aria-hidden="true"></i> Interest</a>
                <a v-if="profiledetails.status =='Uninterest' && profiledetails.statusval !='Declined' && profiledetails.statusval !='cancelled'" class="button btn-align sbtn mr-3 btn-sm accent-btn rounded raised  unintrest pull-right" @click="uninterestRequest()"><i class="uil uil-thumbs-down" aria-hidden="true"></i> Uninterest</a>
                <a v-if="profiledetails.status =='Accept' && profiledetails.statusval !='Declined' && profiledetails.statusval !='cancelled'" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right" @click="interestRequest(2)"><i class="uil uil-check" aria-hidden="true"></i> Accept</a>
                <!-- <span v-if="profiledetails.status =='Accepted'" class="pull-right mt-2" style="color:#5bad2b"><i class="uil uil-check" aria-hidden="true"></i> Accepted</span> -->
                <span v-if="profiledetails.statusval =='Declined'" class="pull-right mt-2" style="color:#ff2627"><i class="uil uil-times" aria-hidden="true"></i>  Declined</span>
                <span v-if="profiledetails.statusval =='cancelled'" class="pull-right mt-2" style="color:#ff2627"><i class="uil uil-times" aria-hidden="true"></i> Cancelled</span>
              </div>
              <!-- <div class="clearfix">
                <span class="direct-chat-timestamp pull-left"></span>
                <span class="direct-chat-timestamp pull-right" style="color:red" v-if="validationerror">* Choose time to Schedule</span>
              </div> -->
            </div>
            <!-- <div class="direct-chat-msg">
              <div class="clearfix">
                <span class="direct-chat-timestamp pull-left"></span>
                <span class="direct-chat-timestamp pull-right" style="color:red" v-if="validationerror">* Choose time to Schedule</span>
              </div>
              <span class="direct-chat-name pull-right">

                  <a v-if="(profiledetails.status =='Interest' || profiledetails.status =='' || profiledetails.status ==null) && (profiledetails.statusval !=='Declined' && profiledetails.statusval !=='cancelled')" class="button btn-align sbtn mr-3 btn-sm accent-btn rounded pull-right raised" @click="interestRequest()"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i> Interest</a>
                  <a v-if="profiledetails.status =='Uninterest' && profiledetails.statusval !='Declined' && profiledetails.statusval !='cancelled'" class="button btn-align sbtn mr-3 btn-sm accent-btn rounded raised  unintrest" @click="uninterestRequest()"><i class="fa fa-thumbs-o-down" aria-hidden="true"></i> Uninterest</a>
                  <a v-if="profiledetails.status =='Accept' && profiledetails.statusval !='Declined' && profiledetails.statusval !='cancelled'" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right" @click="interestRequest()"><i class="fa fa-check" aria-hidden="true"></i> Accept</a>
                  <span v-if="profiledetails.status =='Accepted'" class="pull-right" style="color:#5bad2b"><i class="fa fa-check" aria-hidden="true"></i> Accepted</span>
                  <span v-if="profiledetails.statusval =='Declined'" class="pull-right" style="color:#ff2627"><i class="fa fa-trash-o" aria-hidden="true"></i>  Declined</span>
                  <span v-if="profiledetails.statusval =='cancelled'" class="pull-right" style="color:#ff2627"><i class="fa fa-times" aria-hidden="true"></i> Cancelled</span>
                <button class="btn btn-default btns pull-left"><i class="fa fa-bookmark" aria-hidden="true"></i> view wishlist</button>
              </span>
            </div> -->
          </div>
        </div>
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li v-bind:class="{'active': tabOne}" @click="tabOne = true, tabTwo = false, tabthree = false"><a href="#tab_1" data-toggle="tab">Profile Details</a></li>
            <li v-bind:class="{'active': tabTwo}" @click="tabOne = false, tabTwo = true, tabthree = false"><a href="#tab_2" data-toggle="tab">Skillset</a></li>
            <li v-bind:class="{'active': tabthree}" @click="tabOne = false, tabTwo = false, tabthree = true"><a href="#tab_3" data-toggle="tab">Availability</a></li>
          </ul>
        </div>
        <div class="row" v-if="tabOne">
          <div class="col-md-7">
            <b>About</b>
            <p v-if="profiledetails.user_bio">{{profiledetails.user_bio}}</p>
            <p v-if="profiledetails.user_bio == '' || profiledetails.user_bio == null">NA</p>
            <hr>
            <!-- <b>Current Status</b><br> -->
            <div class="col-md-6 p-1">
              <div>
                <span class="direct-chat-timestamp pull-left f12">Status</span><br>
                <span class="direct-chat-name pull-left f12">{{profiledetails.organization_status}}</span>
              </div>
            </div>
            <div class="col-md-6 p-1">
              <div class="mt-2 pull-left" v-if="profiledetails.organization_status == 'Employed'">
                <span class="direct-chat-timestamp pull-left f12">Organization</span><br>
                <span class="direct-chat-name pull-left f12" v-if="profiledetails.hide_current_org !='yes'">{{profiledetails.current_user_organization}}</span>
                <span class="direct-chat-name pull-left f12" v-if="profiledetails.hide_current_org =='yes'">--</span>
              </div>
              <div v-if="profiledetails.organization_status != 'Employed'">
                <span class="direct-chat-timestamp pull-left f12">&nbsp;</span><br>
              </div>
            </div>
            <br>
            <div class="col-md-12 p-1">
              <hr>
              <b v-if="resumeurl !='' && resumeurl !=null">Resume</b>
              <div class="box box-info" v-if="resumeurl !='' && resumeurl !=null">
                <div class="box-header with-border" style="background-color: #f5f5f5;">
                  <h3 class="box-title f14"><i class="fa fa-file-pdf-o cg" aria-hidden="true"></i> resume.pdf</h3>
                  <div class="box-tools pull-right">
                    <span class="pull-left resumeview"><i class="fa fa-files-o" aria-hidden="true"></i> <a :href="resumeurl" target="_blank">View</a></span>
                    <!-- <button style="margin-right: 0px;" class="btn btn-default btns resumebtn pull-left"><i class="fa fa-bookmark" aria-hidden="true"></i> view wishlist</button> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <b>Certification</b>
            <div class="box box-info">
              <div class="box-header with-border" style="background-color: #f5f5f5;">
                <h3 class="box-title f14"><i class="fa fa-file-pdf-o cg" aria-hidden="true"></i> resume_name.pdf</h3>
                <div class="box-tools pull-right">
                  <span class="pull-left resumeview"><i class="fa fa-files-o" aria-hidden="true"></i> view</span>
                </div>
              </div>
            </div>
            <div class="box box-info">
              <div class="box-header with-border" style="background-color: #f5f5f5;">
                <h3 class="box-title f14"><i class="fa fa-file-pdf-o cg" aria-hidden="true"></i> resume_name.pdf</h3>
                <div class="box-tools pull-right">
                  <span class="pull-left resumeview"><i class="fa fa-files-o" aria-hidden="true"></i> view</span>
                </div>
              </div>
            </div> -->
          </div>
          <div class="col-md-5">
            <div class="box box-default">
            <div class="box-header chart with-border">
              <h3 class="box-title">Short Intro</h3>
            </div>
            <!-- /.box-header -->
            <div class="box-body tc">
               <div class="player-container" v-if="videourl !='' && videourl !=null">
                    <my-video :sources="video.sources" :options="video.options"></my-video>
               </div>
               <img style="max-width: 180px;width: 100%;padding: 30px;" v-if="videourl =='' || videourl ==null" src="../../assets/img/video_empty.png">
            </div>
          </div>
          <div class="box box-default">
            <div class="box-header chart with-border">
              <h5 class="box-title">Statistics</h5>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <!-- <div class="info-box">
                <span class="info-box-icon bg-yellow">
                  <vc-donut style="width: 52%; margin-top: 9px;margin-left: auto;color: black;margin-right: auto;"
                    background="white" foreground="grey"
                    :size="70" unit="px" :thickness="10" :sections="sections"
                    :total="100"
                    :start-angle="0" :auto-adjust-text-size="true">
                    <h6>75%</h6>
                  </vc-donut>
                </span>
                <div class="info-box-content">
                  <span class="info-box-number">Total interviews completed</span>
                </div>
              </div> -->
              <div class="info-box">
                <div class="info-box-content">
                  <span class="info-box-number">We'll update shortly</span>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="row" v-if="tabTwo">
          <div class="col-md-12">
            <!-- <b>Skillset</b> -->
                  <table class="table table-striped">
                    <tbody>
                      <tr>
                      <th style="width: 40%">Skill</th>
                      <th style="width: 20%">Self Rating</th>
                      <th style="width: 40%">Experience</th>
                    </tr>
                    <tr v-for="(x, index) in profilesills" :key="index">
                      <td><h6>{{x.skill_desc}}</h6></td>
                      <td class="c">
                        <star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="Number(x.self_rating)" :read-only="true"></star-rating>
                      </td>
                      <td class="c">{{x.yearofexperience}} Years {{x.monthofexperience}} Months</td>
                    </tr>
                  </tbody></table>
            <!-- <b>Availability</b>
            <div>
              <ul class="donate-now mt-0 row mb-2" v-for="date in groupeddate" :key="date">
                  <div class="col-md-2">{{date[0].startday}}</div>
                  <div class="col-md-10">
                  <li v-for="time in date" :key="time" style="width: 136px;height: 33px;" @click="getdatetime(time.start_datetime,time.end_datetime)">
                    <input type="radio" :id="time.start_datetime" name="time" />
                    <label :for="time.start_datetime">{{time.start_time}} to {{time.end_time}}</label>
                  </li>
                  </div>
                </ul>
            </div> -->
          </div>
        </div>
        <div class="row" v-if="tabthree">
          <div class="col-md-12">
            <!-- <b>Availability</b> -->
            <div>
              <ul class="donate-now mt-0 row mb-2" v-for="(date, index) in groupeddate" :key="index">
                  <div class="col-md-2">{{date[0].startday}}</div>
                  <div class="col-md-10">
                  <li v-for="(time, index) in date" :key="index" style="width: 136px;height: 33px;" @click="getdatetime(time.start_datetime,time.end_datetime)">
                    <!-- <input type="radio" :id="time.start_datetime" name="time" /> -->
                    <label :for="time.start_datetime">{{time.start_time}} to {{time.end_time}}</label>
                  </li>
                  </div>
                </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div> -->
    </div>
    <!-- /.modal-content -->
  </div>
</div>
</template>
<style scoped>
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      width: 801px;
  }
}
.modal { overflow: auto !important; }
.modal-header {
  padding: 8px !important;
}
img {
    max-width: 64px;
}
.btns {
  background-color: white;
  color: #5bad2b;
  margin-right: 20px;
  height: 32px;
}
.modal-header {
  background-color: #F5F5F5;
  border-bottom: 1px solid #cccccc73;
}
.nav-tabs {
  border-bottom: 0;
  margin-bottom: 0;
  background-color: #f5f5f5;
}
.nav-tabs li {
  width:auto;
}
.nav-tabs li a {
  color:black;
}
.nav-tabs li.active a {
  background-color: #5bad2b;
  color: white;
}
.nav-tabs li.active a:hover {
  background-color: #5bad2b;
  color: white;
}
hr {
    border-top: 1px solid #55555538 !important;
}
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.info-box {
  background-color: #f5f5f5 !important;
}
.bg-yellow {
  border-right: 5px solid white;
  background-color: #f5f5f5 !important;
}
.info-box-content {
    padding: 39px 10px;
    margin-left: 90px;
}
.info-box-number {
  font-size: 12px;
}
.resumeview {
  margin-top: 6px;
  margin-right: 20px;
  color: #5bad2b;
}

.btns.resumebtn {
  color: #2b2fadc7;
  border-color: #2b2fadc7;
}
.btns.resumebtn:hover {
  color: #2b2fadc7;
  border-color: #2b2fadc7 !important;
}
.f14 {
  font-size: 14px !important;
}
.cg {
  color: #5bad2b;
}
.c {
  text-align: center;
}
tr th {
  text-align: center;
}
.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.table>tbody>tr>td {
  padding: 4px;
}
.direct-chat-name.nametext {
  font-size: 14px;
  font-weight: 400;
}
.box-default {
  border: 1px solid #cccccc6e;
}
.box-header.chart {
  background-color: #f5f5f5;
  border: 1px solid #cccccc6e;
}

.button {
  cursor: pointer;
}
a:hover {
  outline: none;
  text-decoration: none;
  color: #5bad2ba3;
}
.nav>li>a {
  position: relative;
  display: block;
  padding: 6px 15px;
}
.__cov-video {
  width: 100%;
  height: 200px !important;
  vertical-align: bottom;
}
</style>
